import React from "react";
import { Car } from "../../services/mobile";
import styled from "styled-components";
import theme from "../../styles/theme";
import H2 from "../../styles/H2";
import Price from "../../styles/Price";
import CarFeatures from "../CarFeatures";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.1);
  border-radius: 40px 0px;
  margin-bottom: ${theme.unit * 2}px;
  background-color: ${theme.colors.white};
  flex-direction: column;
  h2,
  p {
    margin-bottom: ${theme.unit * 2}px;
  }

  @media (min-width: ${theme.mediaQueries.tablet}px) {
    flex-direction: row;
  }
`;

const ContentWrapper = styled.div`
  margin: ${theme.unit * 2}px ${theme.unit}px;

  @media (min-width: ${theme.mediaQueries.tablet}px) {
    margin: ${theme.unit * 2}px ${theme.unit * 4}px;
  }
`;

const Image = styled.img`
  max-width: 100%;

  @media (min-width: ${theme.mediaQueries.tablet}px) {
    max-width: 340px;
    max-height: 255px;
    width: auto;
    height: auto;
  }
`;

interface Props {
  car: Car;
  onClickCar: (carId: Car["id"]) => any;
}

const CarItem = ({ car, onClickCar }: Props) => {
  return (
    <Wrapper onClick={onClickCar(car.id)}>
      {car.images.length > 0 && <Image src={car.images[0]} />}
      <ContentWrapper>
        <H2 color="alternate">
          {car.brand} {car.modelDescription}
        </H2>
        <CarFeatures car={car} />
        <Price car={car} />
      </ContentWrapper>
    </Wrapper>
  );
};

export default CarItem;
